import { getAmplitudeInstance } from '../amplitudeHelpers';
import GallerySection from '../enums/GallerySection';
import GalleryViewType from '../enums/GalleryViewType';
import TrailDetailsPhotoSource from '../enums/TrailDetailsPhotoSource';

type logTrailDetailsDistinctTrailPhotosViewedParams = {
  distinct_photos_viewed: number;
  gallerysection?: GallerySection;
  galleryviewtype?: GalleryViewType;
  source: TrailDetailsPhotoSource;
  trail_id: number;
};

/**
 * Fires after the user concludes interaction with photos within the trail page (gallery or hero carousel), counting distinct, unique photos viewed. For hero carousel, this event fires when the user progresses beyond the hero carousel (no longer visible on screen) or exits the app or moves to a new page. Photos counted only when user swipes to view the photo in the hero carousel. The default landing photo is not counted. For the Gallery, event fires when the user exits the gallery, switches to a new gallery section (parent/child), scrolls to a new section in list view, or exits the app on a photo page. Grid photos are not counted. For full Gallery 2.0 criteria, visit Analytics Stories document: https://docs.google.com/document/d/1lpbPMOncLNRdABiMWyhj3A-8QNYdkJhhZeUwrk6ZwMY/edit?usp=sharing
 * @param params - Attributes to log with the amplitude event
 * @param params.distinct_photos_viewed - count of distinct photos viewed in a photo viewing session
 * @param params.gallerysection - tour, latest, seasons, sights, trails (only applicable from park gallery) and all the child sections: full list of sights/attractions here: https://docs.google.com/spreadsheets/d/1rneHqNSvkm9fKLFYHQDE39tEY13hwlOCztrb5TVbmg4/edit?usp=sharing
 * @param params.galleryviewtype - Whether photos are viewed in list or grid mode
 * @param params.source - the location in which the photo viewing session occurred (e.g. hero carousel, photo gallery)
 * @param params.trail_id - the trail id of the item the user selected
 */
const logTrailDetailsDistinctTrailPhotosViewed = (
  { distinct_photos_viewed, gallerysection, galleryviewtype, source, trail_id }: logTrailDetailsDistinctTrailPhotosViewedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details distinct trail photos viewed',
    { 'distinct photos viewed': distinct_photos_viewed, gallerysection, galleryviewtype, source, 'trail id': trail_id },
    callback
  );
};

export default logTrailDetailsDistinctTrailPhotosViewed;
